// extracted by mini-css-extract-plugin
module.exports = {"pagination":"index_pagination__NVAb4","pagination__bullet--active":"index_pagination__bullet--active__bNra8","pagination__bullet--hidden":"index_pagination__bullet--hidden__6MXwl"};